import { SeverityType, PerformanceType } from '../constant';
import { AirTrackerPlugin } from '../interface/plugins';
import { canUseResourceTiming, checkIfInWhiteList, formatUrl, getQueryString, getReportVal, urlIsHttps, } from '../util/index';
// for all the initiator type, refer to :https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming/initiatorType
const ASSETS_INITIATOR_TYPE = ['img', 'css', 'script', 'link', 'audio', 'video', 'iframe'];
// for all the entryType, refer to https://developer.mozilla.org/en-US/docs/Web/API/PerformanceEntry/entryType
const COLLECTED_ENTRY_TYPE = 'resource';
// detail of PerformanceResourceTiming: https://developer.mozilla.org/en-US/docs/Web/API/PerformanceResourceTiming
const generateSpeedLog = (entry) => {
    const resourceURl = entry.name;
    return {
        url: formatUrl(resourceURl),
        method: 'get',
        // duration = redirect + DNS + CONNECTION + request + response
        duration: Number(entry.duration.toFixed(2)),
        type: 'static',
        isHttps: urlIsHttps(resourceURl),
        urlQuery: getQueryString(resourceURl),
        domainLookup: getReportVal(entry.domainLookupEnd - entry.domainLookupStart),
        connectTime: getReportVal(entry.connectEnd - entry.connectStart), // TCP/TLS/QUIC timing
    };
};
const publishSpeedLogs = (entries, airTracker) => {
    for (let i = 0, l = entries.length; i < l; i++) {
        const entry = entries[i];
        // only listen on static file type
        if (ASSETS_INITIATOR_TYPE.indexOf(entry.initiatorType) !== -1 &&
            checkIfInWhiteList(entry.name, airTracker.config.assetSpeedMonitoringWhiteList)) {
            airTracker.normalLogPipeLine({
                severity: SeverityType.PERFORMANCE,
                eventName: PerformanceType.ASSETS_SPEED,
                log: generateSpeedLog(entry),
            });
        }
    }
};
export const assetSpeedPlugin = new AirTrackerPlugin({
    name: 'assetsSpeedPlugin',
    setUp: (airTracker) => {
        if (!canUseResourceTiming())
            return;
        let collectCur = 0;
        window.performance.onresourcetimingbufferfull = () => {
            collectCur = 0;
            window.performance.clearResourceTimings();
        };
        if (typeof window.PerformanceObserver === 'function') {
            // trigger report on init
            publishSpeedLogs(window.performance.getEntriesByType(COLLECTED_ENTRY_TYPE), airTracker);
            // the following performance report is based on observer
            const observer = new window.PerformanceObserver((list) => {
                publishSpeedLogs(list.getEntries(), airTracker);
            });
            observer.observe({ entryTypes: [COLLECTED_ENTRY_TYPE] });
        }
        else {
            // TODO: need to clear interval when destroyed
            setInterval(() => {
                const allEntries = window.performance.getEntriesByType(COLLECTED_ENTRY_TYPE);
                const collectEntries = allEntries.slice(collectCur);
                collectCur = allEntries.length;
                publishSpeedLogs(collectEntries, airTracker);
            }, 3000);
        }
    },
});
